<template>
  <div>
    <v-card class="mx-auto my-4" max-width="550">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="5" class="d-none d-sm-block">
            <v-img src="../assets/Gandalf.png"></v-img>
          </v-col>
          <v-col sm="7">
            <v-row>
              <v-col cols="12">
                <p class="text-center text-h5 mt-5">YOU SHALL NOT PASS!</p>
              </v-col>
              <v-col cols="12" class="mt-0 pt-0">
                <p
                  class="text-center text-h2 mt-0 pt-0 orange--text font-weight-bold"
                >
                  403
                </p>
              </v-col>
              <v-col cols="12" class="mt-0 pt-0">
                <p class="text-center text-h7 mt-0 pt-0">
                  We are sorry, but you do not have access to this page or
                  resource.
                </p>
              </v-col>
              <v-col cols="12" class="text-center mt-0 pt-0">
                <v-btn color="primary" to="/">Back to home page</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$utils.visit(this);
  },
};
</script>

<style></style>
